import { motion } from "framer-motion";
import { Reveal } from "../utils/Reveal";

const AboutDetailsSection = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.5 }}
      className="flex flex-col min-h-fit items-center justify-start text-center xl:text-left xl:flex-row max-w-7xl px-4 mx-auto md:pt-0 md:pb-12 md:mx-20 z-10"
    >
      <div className="space-y-5 ml-0  xl:pt-0 xl:ml-20 md:pt-10">
        <h4 className="text-2xl font-medium text-amber-600 dark:text-amber-300">
          <Reveal width="100%">Introduction</Reveal>
        </h4>
        {/* <div className="bg-white dark:bg-[#101111] p-5 rounded-3xl shadow-lg shadow-gray-400/50 dark:shadow-black/30 text-gray-800 dark:text-gray-300 "> */}
        <div className="bg-white/70 dark:bg-[#101111]/70 p-5 rounded-3xl shadow-lg shadow-gray-400/50 dark:shadow-black/30 text-gray-800 dark:text-gray-300 backdrop-filter backdrop-blur-lg bg-opacity-30 ease-in-out">
          {/* border dark:border-white/5 border-black/10 */}
          <p className="text-sm font-light">
            Hi there, my name is{" "}
            <span className="font-semibold text-black dark:text-white">
              Francen Timothy Castro - A Fullstack Developer
            </span>
            . I am an experienced Full-Stack Developer with a strong background in delivering scalable, high-performing web and mobile applications across diverse industries.<br />
            <br />{" "}
            I work across the stack, using React, Next.js, or Vue.js on the frontend to create clean, responsive interfaces, and
            Node.js, PHP (Laravel), or Python (FastAPI, Flask) on the backend to build secure, scalable systems.
            I’ve developed a wide range of projects, including marketplaces, dashboards, eCommerce platforms, and realtime applications, always focusing on performance, reliability, and a smooth user experience.
            I’m comfortable working with MySQL, PostgreSQL, and MongoDB, and I use Docker, AWS, and CI/CD pipelines to
            make deployment fast and dependable.
          </p>
        </div>
      </div>
    </motion.div>
  );
};
export default AboutDetailsSection;
